// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + (chunkId === 239 ? "BookPreviewer" : chunkId) + "." + {"239":"f4cbd2e4","942":"0b52ed86"}[chunkId] + ".css";
};